/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavRecordUpdate = {
  readonly id?: number;
  readonly firm?: number;
  readonly company?: number;
  readonly date?: string;
  readonly status?: string;
  reviewed_by_scalar?: boolean;
  discussed_with_fund?: boolean;
  price_adjusted?: boolean | null;
  /**
   * When a 'Yes' price adjustment is expected. Required alongside price_adjusted=true; 'next_day' defers the new price to the next trading session and carries a Needs New Price obligation onto it.
   */
  price_adjustment_timing?: DailyNavRecordUpdate.price_adjustment_timing | null;
  readonly pending_price_adjustment?: boolean;
  readonly reviewed_by_scalar_at?: string | null;
  readonly discussed_with_fund_at?: string | null;
  readonly price_adjusted_at?: string | null;
  review_notes?: string | null;
  /**
   * The FINAL allocation this NAV day opened against, carried from the previous NAV day's closed_allocation. Written at generation. Null on days generated before this was tracked, and on a company with no prior FINAL allocation.
   */
  readonly previous_allocation?: number | null;
  /**
   * The FINAL allocation this NAV day's price came from. Written at finalize. Null on a day that was never finalized, and on rows migrated from the old measurement-date link whose allocation could not be resolved unambiguously.
   */
  readonly closed_allocation?: number | null;
  readonly last_modified_by?: number | null;
  readonly last_modified_at?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace DailyNavRecordUpdate {
  /**
   * When a 'Yes' price adjustment is expected. Required alongside price_adjusted=true; 'next_day' defers the new price to the next trading session and carries a Needs New Price obligation onto it.
   */
  export enum price_adjustment_timing {
    TODAY = 'today',
    NEXT_DAY = 'next_day',
  }
}

